<template>
	<div class="card">
		<div v-if="loadingGruposFactores">
			<preloader></preloader>
		</div>
		<div class="card-body">
			<h3 class="text-muted">
				<i class="material-icons">group</i> Grupo factor análisis
				<div class="float-right">
					<button type="button" class="btn btn-success" v-on:click="addGrupo()">
						<i class="material-icons">add</i> Agregar
					</button>
				</div>
			</h3>
			
			<div>
				<div :class="{'table-responsive':true, 'position-relative':loadingGruposFactores}" v-if="grupos.data.length>0">
					<div class="table-loading" v-if="loadingGruposFactores">
						<div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
							<span class="sr-only">Cargando...</span>
						</div>
						<h5 class="m-0">Cargando..</h5>
					</div>
					<table class="table table-bordered table-hover table-striped table-sm">
						<thead>
							<tr>
								<th class="border-0">Código</th>
								<th class="border-0">Decripción</th>
								<th class="border-0">Tipo</th>
								<th class="border-0">Peso</th>
								<th class="border-0"></th>
							</tr>
							<tr>
								<td colspan="8" class="p-1 border-0">
									<div class="text-muted text-uppercase font-weight-bolder text-monospace text-left">
										Grupos factor análisis ({{grupos.total}})
									</div>
								</td>
							</tr>
						</thead>
						<tbody>
							<tr v-for="grupo in grupos.data" class="cursor-pointer" v-on:click.prevent="showGrupo(grupo)">
								<th width="60px">{{grupo.CODIGO_GRUPO_ANALISIS}}</th>
								<th>{{grupo.DESCRIPCION_GRUPO}}</th>
								<th>{{grupo.TIPO}}</th>
								<th class="text-right">{{grupo.PORCENTAJE_PESO}}%</th>
								<td class="text-right" width="100px">
									<div class="btn-group text-right">
										<a
										href="#"
										class="text-muted ml-2 p-1"
										v-tooltip="'Eliminar grupo'"
										v-on:click.prevent.stop="deleteGrupo(grupo.CODIGO_GRUPO_ANALISIS)">
											<i class="material-icons">delete</i>
										</a>

										<a
										href="#"
										class="text-muted ml-2 p-1"
										v-tooltip="'Editar grupo'"
										v-on:click.prevent.stop="editGrupo(grupo)">
											<i class="material-icons">edit</i>
										</a>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div v-else>
					<empty icon="hourglass_empty" title="No hay información." description="No hay información relacionada a los grupos.">
					</empty>
				</div>
				<paginacion
					:pagination="grupos"
					@paginate="getGrupos()"
					:offset="4">
				</paginacion>
			</div>
			
			<div class="modal fade" id="grupoModal" role="dialog" aria-labelledby="grupoModalLabel" aria-hidden="true" data-backdrop="static" >
				<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h3 v-if="route=='create'">
								<i class="material-icons">add</i>
								Agregar grupo
							</h3>
							<h3 v-if="route=='edit'">
								<i class="material-icons">edit</i>
								Editar grupo
							</h3>
							<h3 v-if="route=='show'">
								<i class="material-icons">search</i>
								Ver grupo
							</h3>
						</div>
						<div v-if="loadingGruposFactores">
							<preloader></preloader>
						</div>
						<div class="modal-body">
							<div class="row" v-if="route!='index'">
								<div class="col-md-12 mb-3">
									<label>Descripción grupo:</label>
									<input class="form-control form-control-sm" v-model="grupo.descripcion_grupo" maxlength="150" v-if="route!='show'">
									<p v-else>{{grupo.descripcion_grupo}}</p>
									<div v-if="errors && errors.descripcion_grupo" class="text-danger">
				                        {{ errors.descripcion_grupo[0] }}
				                    </div>
								</div>

								<div class="col-md-12 mb-3">
									<label>Peso:</label>
									<div class="input-group mb-3" v-if="route!='show'">
										<decimal v-model="grupo.peso" max="100" min="0"></decimal>
										<div class="input-group-append">
											<span class="input-group-text border-0">%</span>
										</div>
									</div>
									<p v-else>{{grupo.peso}}</p>
									<div v-if="errors && errors.peso" class="text-danger">
				                        {{ errors.peso[0] }}
				                    </div>
								</div>

								<div class="col-md-12 mb-3">
									<label>Tipo:</label>
									<select2 v-model="grupo.tipo" v-if="route!='show'">
										<option value="cualitativo">Cualitativo</option>
										<option value="cuantitativo">Cuantitativo</option>
									</select2>
									<p v-else>{{grupo.tipo}}</p>
									<div v-if="errors && errors.tipo" class="text-danger">
				                        {{ errors.tipo[0] }}
				                    </div>
								</div>
							</div>

						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-success" v-if="route=='create'" v-on:click="storeGrupo()">
								Agregar grupo
							</button>
							<button type="button" class="btn btn-info" v-if="route=='edit'" v-on:click="updateGrupo()">
								Actualizar grupo
							</button>
							<button type="button" class="btn btn-light" v-on:click="cancelAction()">
								Cancelar
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default{
		props: ['vendedor'],

		data(){
			return {
				grupos: {
		            total: 0,
		            per_page: '',
		            data: [],
		            from: 1,
		            to: 0,
		            current_page: 1
		        },
		        loadingGruposFactores: false,
				grupo: {
					codigo: '',
					descripcion_grupo: '',
					peso: '',
					tipo: '',
					fecha_actualizacion: '',
					creado_desde: '',
					actualizado_desde: '',
					creado_por: {
						codigo: '',
						nombre: '',
					},
					actualizado_por: {
						codigo: '',
						nombre: '',
					},
				},
				errors: {},
				route: 'index'
			}
		},

		mounted() {
			this.getGrupos()
		},

		methods: {
			getGrupos: function(validatePage = false){
				this.loadingGruposFactores = true
				if (validatePage) {
					this.grupos.current_page = 1
				}

				axios.get(`api/factores/grupos`,{
					params: {
						page: this.grupos.current_page,
						per_page: this.grupos.per_page
					}
				})
				.then(response => {
					this.grupos = response.data
				}).catch(error => {
					console.log(error.response)
				}).then(()=>{
					this.loadingGruposFactores = false
				})
			},

			addGrupo(){
				this.route = 'create'
				this.cleanFields()
				$('#grupoModal').modal('show')
			},

			storeGrupo(){
				this.loadingGruposFactores = true
				
				axios.post(`api/factores/grupos`, this.grupo)
				.then(response => {
					this.getGrupos()
					this.route = 'index'
					this.cleanFields()
					this.$toasted.show('Grupo agregado')
					$('#grupoModal').modal('hide')
				}).catch(error => {
					console.log(error.response)
					if (error.response.status === 422) {
			        	this.errors = error.response.data.errors || {};
			        }
				}).then(()=>{
					this.loadingGruposFactores = false
				})
			},

			editGrupo: function(data){
				this.route = 'edit'
				this.grupo.codigo = data.CODIGO_GRUPO_ANALISIS
				this.grupo.descripcion_grupo = data.DESCRIPCION_GRUPO
				this.grupo.peso = data.PORCENTAJE_PESO
				this.grupo.tipo = data.TIPO
				this.errors = {}
				$('#grupoModal').modal('show')
			},

			updateGrupo(){
				if (!this.grupo.codigo) {
					return
				}
				this.loadingGruposFactores = true
				
				axios.put(`api/factores/grupos/${this.grupo.codigo}`, this.grupo)
				.then(response => {
					this.getGrupos()
					this.route = 'index'
					this.cleanFields()
					this.$toasted.show('Grupo actualizada')
					$('#grupoModal').modal('hide')
				}).catch(error => {
					console.log(error.response)
					if (error.response.status === 422) {
			        	this.errors = error.response.data.errors || {};
			        }
				}).then(()=>{
					this.loadingGruposFactores = false
				})
			},

			showGrupo: function(data){
				this.route = 'show'
				this.grupo.codigo = data.CODIGO_GRUPO_ANALISIS
				this.grupo.descripcion_grupo = data.DESCRIPCION_GRUPO
				this.grupo.peso = data.PORCENTAJE_PESO
				this.grupo.tipo = data.TIPO
				this.errors = {}
				$('#grupoModal').modal('show')
			},

			deleteGrupo: function(codigo){
				var url = `api/factores/grupos/${codigo}`
				var modules = this

				$.confirm({
			        title: '¿Estás seguro?',
			        content: '¡Ya no podrás recuperar esta información!',
			        theme: 'supervan', // 'material', 'bootstrap'
			        buttons: {
			            Confirmar: function () {
			                axios.delete(url)
			                    .then(response => {
			                    	modules.getGrupos()
			                        modules.$toasted.show('Eliminado')
			                    })
			                    .catch(error => {
			                        console.log(error.response)
			                        if (error.response.status === 422) {
							        	modules.$toasted.show(error.response.data)
							        }else{
							        	modules.$toasted.show('Error al Eliminar')
							        }
			                    })
			            },
			            Cancelar: function () {
			            },
			        }
			    })
			},

			cancelAction: function(){
				this.route = 'index'
				this.cleanFields()
				$('#grupoModal').modal('hide')
			},

			cleanFields: function(){
				this.grupo.codigo= ''
				this.grupo.descripcion_grupo= ''
				this.grupo.peso= ''
				this.grupo.tipo= ''
				this.grupo.fecha_actualizacion= ''
				this.grupo.creado_desde= ''
				this.grupo.actualizado_desde= ''
				this.grupo.creado_por.codigo= ''
				this.grupo.creado_por.nombre= ''
				this.grupo.actualizado_por.codigo= ''
				this.grupo.actualizado_por.nombre= ''
				this.errors = {}
			}
		},

		computed: {
			requerimientoFilter: function(){
				return this.requerimiento
			},

			codigoVendedor: function(){
				return this.vendedor
			}

		},

		watch: {
			requerimientoFilter: function(val, oldVal){
				if (oldVal == val) {
					return
				}
				this.getGrupos(true)
			}
		},

		filters: {
			nameMonth: function(value){
				var months = [
					'Enero',
					'Febrero',
					'Marzo',
					'Abril',
					'Mayo',
					'Junio',
					'Julio',
					'Agosto',
					'Septiembre',
					'Octubre',
					'Noviembre',
					'Diciembre'
				]

				if (value <= 0 || value >= 12) {return ''}

				return months[value-1]
			}
		}
	}
</script>